import { useState, useEffect, useRef } from 'react';
import { bookingUrl } from '@/lib/booking';
import { CalendarDays } from 'lucide-react';

const BOOK_A_CALL_URL = bookingUrl('floating');

export function FloatingBookCall() {
  const [visible, setVisible] = useState(false);
  const sentinelTopRef = useRef<HTMLDivElement | null>(null);
  const sentinelBottomRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    // Find the hero sentinel and footer sentinel added by the page
    const heroEl = document.getElementById('hero-sentinel');
    const footerEl = document.getElementById('footer-sentinel');
    if (!heroEl && !footerEl) {
      // Fallback: show after scroll
      const onScroll = () => setVisible(window.scrollY > 400);
      window.addEventListener('scroll', onScroll, { passive: true });
      return () => window.removeEventListener('scroll', onScroll);
    }

    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.target.id === 'hero-sentinel' && !entry.isIntersecting) {
          setVisible(true);
        }
        if (entry.target.id === 'footer-sentinel' && entry.isIntersecting) {
          setVisible(false);
        }
      });
    });

    if (heroEl) io.observe(heroEl);
    if (footerEl) io.observe(footerEl);
    return () => io.disconnect();
  }, []);

  return (
    <a
      href={BOOK_A_CALL_URL}
      target="_blank"
      rel="noopener"
      aria-label="Book a call"
      className="fixed bottom-6 right-6 z-30 flex items-center gap-2 shadow-lg transition-all duration-200"
      style={{
        background: 'var(--warm-btn)',
        color: 'var(--warm-btn-text)',
        borderRadius: '24px',
        padding: '10px 18px',
        fontSize: '14px',
        fontWeight: 500,
        opacity: visible ? 1 : 0,
        pointerEvents: visible ? 'auto' : 'none',
        transform: visible ? 'translateY(0)' : 'translateY(8px)',
      }}
    >
      <CalendarDays className="size-4 shrink-0" />
      <span className="hidden sm:inline">Book a call</span>
    </a>
  );
}
